{
  "cms.editor.back": "Takaisin",
  "cms.editor.cancel": "Peruuta",
  "cms.editor.title": "Muokkaus",
  "cms.editor.page.heading": "Muokkaa sivua",
  "cms.editor.lockedDestination.state": "Lukittu tila",
  "cms.editor.lockedDestination.description": "Tämä näkymä on kiinteä eikä sitä voi muokata tästä.",
  "cms.editorPreviewSlot.placeholder.body": "Esikatselu ei ole vielä käytössä.",
  "cms.editorPreviewSlot.title": "Esikatselu",
  "cms.form.sidebarLink.error.labelRequired": "Ylempi rivi on pakollinen.",
  "cms.form.sidebarLink.error.routeRequired": "Valitse reitti.",
  "cms.form.sidebarLink.error.subtitleRequired": "Alempi rivi on pakollinen.",
  "cms.form.sidebarLink.icon": "Ikoni",
  "cms.form.sidebarLink.iconNone": "Ei kuvaketta",
  "cms.form.sidebarLink.label": "Ylempi rivi",
  "cms.form.sidebarLink.route": "Reitti",
  "cms.form.sidebarLink.routePlaceholder": "Valitse reitti",
  "cms.form.sidebarLink.subtitle": "Alempi rivi",
  "cms.form.sidebarLink.tab": "Etusivun välilehti",
  "cms.form.sidebarLink.tab.lakikaveri": "Lakikaveri",
  "cms.form.sidebarLink.tab.palvelut": "Jäsenyys ja edut",
  "cms.form.sidebarLink.targetKind": "Kohde",
  "cms.form.sidebarLink.targetKind.page": "Palvelusivu",
  "cms.form.sidebarLink.targetKind.route": "Sivuston osio",
  "cms.publish.success": "Julkaistu tuotantoon.",
  "cms.saveDraft.success": "Luonnos tallennettu."
}
